import {createSmartAction} from 'redux-smart-actions';
import {push} from 'connected-react-router';

export const getRegisterInfo = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/form?wp_form_id=inscription_form',
  },
}));

export const postRegisterInfo = createSmartAction((data = {}) => {
  const bodyFormData = new FormData();
  Object.keys(data).forEach(key => bodyFormData.append(key, data[key]));
  bodyFormData.append('wp_form_id', 'inscription_form');

  return {
    request: {
      url: '/mco-leclub-api/v1/form',
      method: 'post',
      headers: {'Content-Type': 'multipart/form-data'},
      data: bodyFormData,
    },
    meta: {
      onSuccess: (response, requestAction, {dispatch}) => {
        dispatch(
          push({
            pathname: '/login',
            state: {confirmRegister: true},
          }),
        );
        return response;
      },
    },
  };
});
